export default __webpack_public_path__ + "static/media/ic_contact.4197d93d.svg";